import { Fragment, useEffect } from "react";
import useSharedData from "../../hooks/useSharedData";

function LiveChat() {
  const { user } = useSharedData();

  const key = "1x27h2";
  const url = "https://www.goftino.com/widget/";

  const create = () => {
    const script = document.createElement("script");
    const local = localStorage.getItem("goftino_" + key);
    const path = url + key;

    script.async = true;
    script.src = local ? path + "?o=" + local : path;

    document.getElementsByTagName("head")[0].appendChild(script);
  };

  useEffect(() => {
    create();

    if (user) {
      const name = user.name + " " + user.family;
      const phone = user.phone;

      const addUserInfo = () => {
        window.Goftino.setUser({
          name: name,
          phone: phone,
          forceUpdate: true,
        });

        window.Goftino.setWidget({
          cssUrl: "./LiveChat.css",
        });
      };

      window.addEventListener("goftino_ready", addUserInfo);
      return () => window.removeEventListener("goftino_ready", addUserInfo);
    }
  }, []);

  return <Fragment></Fragment>;
}

export default LiveChat;
